import { render } from "./ThemesPage.vue?vue&type=template&id=4550da8d"
import script from "./ThemesPage.vue?vue&type=script&lang=js"
export * from "./ThemesPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/learnbil/public_html/learnbilly.com/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__